import apiClient from './apiClient';

/**
 * Loads the running API build version from the public `/api/version` probe.
 * The endpoint intentionally returns a JSON string; keep that transport detail
 * at this edge so version UI only consumes a normalized value.
 */
export async function fetchBackendVersion(): Promise<string> {
  const response = await apiClient.get<unknown>('/version');
  const version = typeof response.data === 'string' ? response.data.trim() : '';

  if (!version) {
    throw new Error('Backend version response was empty');
  }

  return version;
}
